import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { FormControl, useTheme } from '@mui/material';
import PropTypes from 'prop-types';
import { useState } from 'react';

import { TrlChevronArrow } from '»components/atoms';

import {
  CheckIconStyled,
  LabelStyled,
  MenuItemStyled,
  SelectStyled,
} from './TrlDropdown.styles';

const getArrow = (props) => <TrlChevronArrow {...props} />;

export const TrlDropdown = ({ label, options, value, isSmall, ...rest }) => {
  const [isOpen, setIsOpen] = useState(false);

  const theme = useTheme();

  const handleIsOpen = () => {
    setIsOpen((prevValue) => !prevValue);
  };

  const { field, form, disabled } = rest;

  return (
    <FormControl fullWidth={!isSmall} disabled={disabled}>
      {label && <LabelStyled>{label}</LabelStyled>}
      <SelectStyled
        value={field?.value ?? value ?? ''}
        MenuProps={{
          PaperProps: {
            sx: {
              backgroundColor: theme.palette.colors.infoBackground,
              boxShadow: 'none',
              borderRadius: '5px',
            },
          },
        }}
        open={isOpen}
        {...rest}
        onOpen={handleIsOpen}
        onClose={handleIsOpen}
        IconComponent={getArrow}
        isSmall={isSmall}
        {...(field && {
          onChange: (e) => form.setFieldValue(field.name, e.target.value),
        })}
      >
        {options.map((option) => {
          return (
            <MenuItemStyled key={option.value} value={option.value}>
              {option.label}
              <CheckIconStyled icon={faCheck} />
            </MenuItemStyled>
          );
        })}
      </SelectStyled>
    </FormControl>
  );
};
TrlDropdown.propTypes = {
  label: PropTypes.string,
  options: PropTypes.array,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  isSmall: PropTypes.bool,
};
